import React, { useEffect, useState } from 'react';
import OrgMini from '../../components/resellers/OrgMini';
import InvoicingMini from '../../components/resellers/InvoicingMini';
import CrmMini from '../../components/resellers/CrmMini';
import styles from './ResellerDashboard.module.css';

function ResellerDashboard({ user }) {
  const [showGreeting, setShowGreeting] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setShowGreeting(false), 4000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={styles.dashboardContainer}>
      {showGreeting && (
        <h1 className={styles.welcomeText}>
          Welcome, {user?.name || 'Reseller'}!
        </h1>
      )}

      <div className={styles.gridLayout}>
        <CrmMini />
        <OrgMini />
        <InvoicingMini />
      </div>
    </div>
  );
}

export default ResellerDashboard;
